import axios, { AxiosInstance } from 'axios';

const instance = axios.create({
	headers: {
		Accept: 'application/json',
	},
});

export const axiosInstance: AxiosInstance = instance;
